import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNotify } from "react-admin";
import { useFormContext } from "react-hook-form";
import { applyPreset } from "./madrasa-office-preset";

/** Ticks the "Madrasa Office" permissions in the Admin form (adds to, never replaces, what is set). */
export function MadrasaOfficePresetButton({ source = "permissions" }: { source?: string }) {
  const { getValues, setValue } = useFormContext();
  const notify = useNotify();

  const apply = () => {
    const { next, added } = applyPreset(getValues(source) as string[] | undefined);
    setValue(source, next, { shouldDirty: true });
    notify(
      added.length
        ? `Ticked ${added.length} madrasa ${added.length === 1 ? "permission" : "permissions"}. Review them below, then save.`
        : "This admin already has all the Madrasa Office permissions.",
      { type: added.length ? "success" : "info" }
    );
  };

  return (
    <Box sx={{ mb: 1 }}>
      <Button variant="outlined" size="small" onClick={apply}>
        Add Madrasa Office permissions
      </Button>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
        For office staff: register and enroll students, collect fees, view reports. Does not allow
        deleting, changing fees, voiding receipts or changing settings.
      </Typography>
    </Box>
  );
}
